/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/SessionsPageQuery$parameters';
import type { SessionsPageQuery$variables } from './__generated__/SessionsPageQuery.graphql';
import type { Queries } from './SessionsPage.types.tsx';

type SoftwareSessionsEntrypointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const softwareSessionsEntrypoint: EntryPoint<
	SoftwareSessionsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SoftwareSessionsEntrypointComponent>(
		/* webpackChunkName: "async-software-sessions-entrypoint" */ './SessionsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
		tenantContext: { cloudId },
	}: EntryPointRouteParams) => {
		// Exactly one scope field may be provided; prefer boardId over the project's space key.
		const scope: SessionsPageQuery$variables['scope'] =
			params.boardId != null
				? { boardId: String(params.boardId) }
				: { spaceKey: String(params.projectKey) };

		return {
			queries: {
				sessions: {
					options: { fetchPolicy: 'store-or-network' as const },
					parameters,
					variables: { cloudId, scope },
				},
			},
		};
	},
});
